import { useAppSelector } from 'app/state'
import { CommonPrivacy } from 'features/common'
import { WorkflowPrivacy, WorkflowsPermissionsType } from 'features/workflows/enums'
import { useMemo } from 'react'

export function useWorkflowsPermissionsMapping() {
  const ownerId = useAppSelector((state) => state.users.me?.user_id)
  const PermissionsMapping = useMemo(
    () => ({
      [WorkflowsPermissionsType.All]: {
        user_id: undefined,
        privacy: undefined
      },
      [WorkflowsPermissionsType.Mine]: {
        user_id: ownerId,
        privacy: undefined
      },
      [WorkflowsPermissionsType.Shared]: {
        user_id: undefined,
        privacy: CommonPrivacy.Shared as WorkflowPrivacy
      }
    }),
    [ownerId]
  )
  return (permissions: WorkflowsPermissionsType) => PermissionsMapping[permissions]
}
